import { combineReducers } from 'redux';
import { adminReducer } from './AdminReducer';
import { alert } from './AlertReducer';
import { companyReducer } from './CompanyReducer';
import { festivalReducer } from './FestivalReducer';
import { musicDirectorReducer } from './MusicDirectorReducer';
import { userReducer } from './UserReducer';
import { emailTemplateReducer } from './EmailTemplateReducer';
import testimonialReducer from './testimonialReducer';

const rootReducer = combineReducers({
  adminReducer,
  companyReducer,
  festivalReducer,
  musicDirectorReducer,
  userReducer,
  alert,
  emailTemplateReducer,
  testimonialReducer
});

export default rootReducer;


// import { ADD_ARTICLE } from '../constant/article-action-types';

// const intitialState = {
// 	articles : [
// 		{
// 			id: 1,
// 			title : 'hassan'
// 		}
// 	]
// };

// const rootReducer = (state = intitialState , action) =>{
// 	switch(action.type) {
// 		case ADD_ARTICLE :
// 			return { ...state, articles : [...state.articles, action.payload] };
// 		default:
// 			return state;
// 	}
// };

// export default rootReducer;


// WEBPACK FOOTER //
// ./src/redux/reducers/index.jsx